import { handleAxiosErrors } from '../../_utils';
import { convertUserDetailedInformationToAReadableFormat } from '../../selectors/converterSelector';
import {
    toggleLoading,
    setUserInfo,
    axiosDeletePreferredSupplier,
    axiosRequestPreferredSuppliers,
} from '../userActions';

/**
 * Request Wholesaler Reseller
 */
export const requestWholesalerReseller = () => {
    return (dispatch) => {
        dispatch(toggleLoading('wholesalerResellerList', true));
        return axiosRequestPreferredSuppliers()
            .then((response) => {
                const userInfo = convertUserDetailedInformationToAReadableFormat(
                    response.data.data.readOneMember
                );
                dispatch(setUserInfo(userInfo));

                dispatch(toggleLoading('wholesalerResellerList', false));
            })
            .catch((error) => {
                handleAxiosErrors(error);
                dispatch(toggleLoading('wholesalerResellerList', false));
            });
    };
};

/**
 * Delete the selected Wholesaler / Reseller
 *
 * @param supplierID
 * @param callback
 */
export const deleteWholesalerReseller = (supplierID, callback) => {
    return (dispatch) => {
        const successCallback =
            typeof callback.success != 'undefined' ? callback.success : null;
        const errorCallback =
            typeof callback.error != 'undefined' ? callback.error : null;
        const alwaysCallback =
            typeof callback.always != 'undefined' ? callback.always : null;

        return axiosDeletePreferredSupplier([supplierID])
            .then((response) => {
                dispatch(requestWholesalerReseller());

                // Callbacks
                if (successCallback) successCallback(response);
                if (alwaysCallback) alwaysCallback(response);
            })
            .catch((response) => {
                handleAxiosErrors(response);

                // Callbacks
                if (errorCallback) errorCallback(response);
                if (alwaysCallback) alwaysCallback(response);
            });
    };
};
